(() => {
  const script =
    document.currentScript || document.querySelector('script[src*="leo-smooth-scroll"]');

  const strength = Math.min(10, Math.max(1, Number(script?.dataset.strength) || 6));
  const minWidth = Number(script?.dataset.minWidth) || 990;
  const lambda = 14 - strength;

  const pointerQuery = window.matchMedia(`(min-width: ${minWidth}px) and (pointer: fine)`);
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  let target = window.scrollY;
  let current = window.scrollY;
  let rafId = null;
  let lastTime = 0;
  let active = false;

  const isEnabled = () => pointerQuery.matches && !motionQuery.matches;

  const maxScroll = () =>
    Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

  const clamp = (value) => Math.min(maxScroll(), Math.max(0, value));

  const isLocked = () => {
    if (document.documentElement.hasAttribute('scroll-lock')) return true;
    if (document.querySelector('dialog[open]')) return true;
    const style = window.getComputedStyle(document.body);
    return style.overflow === 'hidden' || style.overflowY === 'hidden';
  };

  const consumesDelta = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const delta = event.deltaY;

    for (const node of path) {
      if (!(node instanceof Element)) continue;
      if (node === document.body || node === document.documentElement) break;

      const style = window.getComputedStyle(node);
      const overflowY = style.overflowY;
      const scrollable =
        (overflowY === 'auto' || overflowY === 'scroll') &&
        node.scrollHeight > node.clientHeight + 1;

      if (!scrollable) continue;

      const atTop = node.scrollTop <= 0;
      const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;

      if (delta < 0 && atTop) continue;
      if (delta > 0 && atBottom) continue;

      return true;
    }

    return false;
  };

  const normalize = (event) => {
    if (event.deltaMode === 1) return event.deltaY * 16;
    if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
    return event.deltaY;
  };

  const stop = () => {
    if (rafId !== null) cancelAnimationFrame(rafId);
    rafId = null;
    active = false;
    lastTime = 0;
  };

  const frame = (time) => {
    const delta = lastTime ? Math.min(64, time - lastTime) : 16;
    lastTime = time;

    const factor = 1 - Math.exp((-lambda * delta) / 1000);
    current += (target - current) * factor;

    if (Math.abs(target - current) < 0.4) current = target;

    window.scrollTo({ top: current, left: 0, behavior: 'instant' });

    if (current !== target) {
      rafId = requestAnimationFrame(frame);
    } else {
      stop();
    }
  };

  const start = () => {
    if (active) return;
    active = true;
    lastTime = 0;
    rafId = requestAnimationFrame(frame);
  };

  const onWheel = (event) => {
    if (!isEnabled() || event.defaultPrevented) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey) return;
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    if (isLocked() || consumesDelta(event)) return;

    event.preventDefault();

    if (!active) {
      current = window.scrollY;
      target = current;
    }

    target = clamp(target + normalize(event));
    start();
  };

  const onScroll = () => {
    if (!active || Math.abs(window.scrollY - current) > 4) {
      current = window.scrollY;
      target = current;
      if (active) stop();
    }
  };

  const onResize = () => {
    current = window.scrollY;
    target = current;
    stop();
  };

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  pointerQuery.addEventListener('change', onResize);
  motionQuery.addEventListener('change', onResize);
})();
